import React, { createContext, useContext, useState, useCallback } from 'react';

const RecordingContext = createContext();

export const useRecordingContext = () => {
  const context = useContext(RecordingContext);
  if (!context) {
    throw new Error('useRecordingContext must be used within a RecordingContextProvider');
  }
  return context;
};

export const RecordingContextProvider = ({ children }) => {
  const [recordingContext, setRecordingContext] = useState({
    contact: null, // { id, name, surname, type }
  });

  const setContactContext = useCallback((contact) => {
    setRecordingContext(prev => ({
      ...prev,
      contact,
    }));
  }, []);

  const clearContactContext = useCallback(() => {
    setRecordingContext(prev => ({
      ...prev,
      contact: null,
    }));
  }, []);

  const clearAllContext = useCallback(() => {
    setRecordingContext({
      contact: null,
    });
  }, []);

  return (
    <RecordingContext.Provider
      value={{
        recordingContext,
        setContactContext,
        clearContactContext,
        clearAllContext,
      }}
    >
      {children}
    </RecordingContext.Provider>
  );
};




